import { put, call, takeEvery, select, takeLatest } from 'redux-saga/effects';
import { Url } from '@wix/da-url';
import { init, initDone, switchStream, streamLoadMore, initDoneAlready, initStreamDone, streamLoadDone } from './actionCreators';
import { request } from '@wix/da-http-client/pkg/request';
import { EmoteStreamType } from './types';
import { isInitialized, getStream, getActiveStreamType, getSearchType, getSearchQuery } from './selectors';
export function* initHandler(action) {
    const initialized = yield select(isInitialized);
    if (initialized) {
        yield put(initDoneAlready());
        return;
    }
    const result = yield call(request, {
        method: 'get',
        url: `/emotes/official`
    }, getFake('official'));
    if (result && !result.error) {
        yield put(initDone(result));
    }
}
export function* switchStreamHandler(action) {
    const requestedStream = action.payload.streamType;
    const searchType = action.payload.searchType;
    const stream = yield select((state)=>getStream(state, requestedStream));
    // First page already loaded - ignore for search
    if (requestedStream !== EmoteStreamType.SEARCH && stream && stream.results.length > 0) {
        yield put(initStreamDone(requestedStream, null));
        return;
    }
    // Load first page of stream
    const result = yield call(request, {
        method: 'get',
        url: `/emotes/${requestedStream}`,
        params: {
            offset: 0,
            query: action.payload.searchQuery,
            searchType
        }
    }, getFake(requestedStream));
    if (result && !result.error) {
        yield put(initStreamDone(requestedStream, result));
    }
}
export function* loadStreamHandler() {
    const activeStreamType = yield select(getActiveStreamType);
    const searchType = yield select(getSearchType);
    const searchQuery = yield select(getSearchQuery);
    const stream = yield select((state)=>getStream(state, activeStreamType));
    if (!stream.hasMore) {
        return;
    }
    // Load first page of stream
    const result = yield call(request, {
        method: 'get',
        url: `/emotes/${activeStreamType}`,
        params: {
            offset: stream.nextOffset,
            query: searchQuery,
            searchType
        }
    }, getFake(activeStreamType, stream.nextOffset, false));
    if (result && !result.error) {
        yield put(streamLoadDone(activeStreamType, result));
    }
}
export default function* saga() {
    yield takeEvery(init, initHandler);
    yield takeLatest(switchStream, switchStreamHandler);
    yield takeLatest(streamLoadMore, loadStreamHandler);
}
// Testing stuff below
function getFake(type, offset = 0, hasMore = true) {
    return (options)=>{
        // important removes from prod bundle
        if (process.env.NODE_ENV !== 'production') {
            if (window.doError) {
                return {
                    error: 'invalid_request',
                    errorDescription: 'Not logged in.',
                    status: 'error'
                };
            }
            if (type === 'official') {
                const official = [];
                // eslint-disable-next-line global-require
                const emotes = require('@wix/da-sample-data').officialEmotes;
                for(const k in emotes){
                    official.push({
                        type: 'official',
                        src: Url.staticCDNLink(`emoticons${emotes[k].src}`),
                        title: emotes[k].name,
                        width: emotes[k].width,
                        height: emotes[k].height
                    });
                }
                return {
                    hasMore: false,
                    nextOffset: null,
                    results: official
                };
            }
            if (type === 'community') {
                const official = [];
                // eslint-disable-next-line global-require
                const emotes = require('@wix/da-sample-data').officialEmotes;
                for(const k in emotes){
                    official.push({
                        type: 'community',
                        src: `https://orig00.deviantart.net/cf50/f/2014/149/1/4/clapping_pony_icon___rainbow_blitz_by_travispony-d7k9ff7.gif`,
                        title: emotes[k].name,
                        width: 50,
                        height: 50
                    });
                }
                return {
                    hasMore,
                    nextOffset: 50,
                    results: official.slice(0, 50)
                };
            }
            if (type === 'search') {
                const official = [];
                // eslint-disable-next-line global-require
                const emotes = require('@wix/da-sample-data').officialEmotes;
                for(const k in emotes){
                    official.push({
                        type: 'community',
                        src: 'https://orig00.deviantart.net/5b63/f/2018/086/3/0/crying_lynn_by_lunaloudfan10-dc75d9y.gif',
                        title: emotes[k].name,
                        width: 50,
                        height: 50
                    });
                }
                return {
                    hasMore,
                    nextOffset: 50,
                    results: official.slice(0, 50)
                };
            }
            if (type === 'user') {
                const official = [];
                // eslint-disable-next-line global-require
                const userz = require('@wix/da-sample-data').users;
                for (const user of userz){
                    official.push({
                        type: 'user',
                        src: user.usericon,
                        title: user.username,
                        url: Url.userLink(user.username),
                        width: 50,
                        height: 50
                    });
                }
                return {
                    hasMore,
                    nextOffset: 50,
                    results: official.slice(0, 50)
                };
            }
        }
    };
}
